import { atom } from 'recoil';

export const operationIdState = atom<string | undefined>({
  key: 'operationIdState',
  default: undefined,
});

export const sessionIdState = atom<string | undefined>({
  key: 'sessionIdState',
  default: undefined,
});
